@if (isLoadedFilters) {
    @if (displayMode === 'button') {
        <button type="button"
                class="smart-filters-apply-button"
                (click)="applySmartFilter()">
            Применить умный фильтр
        </button>
    }

    @if (displayMode === 'banner' && (abTestVariant === 'blue' || abTestVariant === 'red')) {
        @if (!isUseSmartFilters) {
            <div class="smart-filters-banner {{abTestVariant}}"
                 (click)="applySmartFilter()">
                <div class="wrapper">
                    <div class="title"><span>Улучшите поиск</span>В один клик</div>
                    <div class="subtitle">Чтобы получить проверенные<br>отели для поездки {{ toCountry }}</div>
                    <div class="button">Применить фильтры</div>
                </div>
            </div>
        } @else {
            <div class="smart-filters-banner short {{abTestVariant}}" (click)="applySmartFilter()">
                <div class="wrapper">
                    <div class="title"><span>Улучшите поиск</span>В один клик</div>
                    <div class="button">Применить фильтры</div>
                </div>
            </div>
        }
    }

    @if (displayMode === 'banner' && abTestVariant === 'toggle') {
        <div class="smart-filters-toggle" [style]="place === 'modal' ? 'marginTop:15px' : ''">
            <div class="wrapper">
                <div class="title">Настроили фильтры <br> за вас, <span>Включить?</span></div>
                <div class="toggle">
                    <input type="checkbox" (change)="toggle($event)" [checked]="isOnlySmart">
                    <label></label>
                </div>
            </div>
        </div>
    }

    <div class="hide">
        <div id="ng-modal-apply-smart-filters-content" class="smart-filters-apply-modal2-content">
            <ng-container>
                <div class="title">Мы установили вам популярные фильтры для поездки {{ toCountry }}</div>
                <div class="description">
                    {{ descriptionFromFilters }}
                </div>
                <button type="button" class="btn-close modal2-close">Супер</button>
            </ng-container>
        </div>
    </div>
}


